/* unplugin-vue-components disabled */import { render } from "./MarketList.vue?vue&type=template&id=1ae0c9e0&scoped=true"
import script from "./MarketList.vue?vue&type=script&lang=js"
export * from "./MarketList.vue?vue&type=script&lang=js"

import "./MarketList.vue?vue&type=style&index=0&id=1ae0c9e0&scoped=true&lang=css"

import exportComponent from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ae0c9e0"]])

export default __exports__